module.exports = __webpack_public_path__ + "static/media/en.c7ef7aee.png";